<template>
  <div class="input-input">
    <label class="input-input__unit">
      <span class="input-input__label">{{ $t('control.panel.parameter') }}:</span>

      <input
        class="input-input__input"
        type="text"
        name="custom-parameter"
        v-model="currentParam"
      >
    </label>

    <label class="input-input__unit">
      <span class="input-input__label">{{ $t('control.panel.value') }}:</span>

      <input
        class="input-input__input"
        type="text"
        name="custom-value"
        v-model="currentValue"
      >
    </label>

    <button
      type="button"
      class="input-input__btn btn btn--prim"
      @click="clickHandler"
    >{{ $t('control.panel.send_event') }}</button>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    param: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
  emits: ['change'],
  setup(props, context) {
    const currentParam = ref(props.param);
    const currentValue = ref(props.value);

    const clickHandler = () => {
      context.emit('change', {
        type: props.name,
        value: {
          prop: currentParam.value,
          value: currentValue.value,
        },
      });
    };

    return { currentParam, currentValue, clickHandler };
  },
};
</script>

<style lang="scss">
.input-input {
  $this: 'input-input';

  & + .input-input {
    margin-top: 10px;
  }

  &__unit {
    display: block;

    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  &__label {
    display: block;
    margin-bottom: 5px;
    font-size: 12px;
  }

  &__input {
    width: 100%;
    border: 1px solid $color-periwinkle;
    border-radius: 4px;
    outline: none;
    padding: 5px 10px;
    font-size: 14px;
  }

  &__btn {
    margin-top: 5px;
  }
}
</style>
